<template>
    <div class="section_story">
        <div class="grid-container">
            <section class="section_story--main grid-x grid-padding-x align-center">
                <h2 class="section--title cell small-12 medium-10"><strong>Story</strong></h2>
                <figure class="section_story--image cell small-10 medium-4">
                    <img src="/netemosametemo/static/img/story_img.jpg" alt="Story">
                </figure>
                <article class="cell small-12 medium-6">
                    <section class="section_story--content">
                        <h3 class="section_story--content--title">東京。</h3>
                        <p>丸子亮平は勤務先の会議室へコーヒーを届けに来た泉谷朝子と出会う。ぎこちない態度をとる朝子に惹かれていく亮平。真っ直ぐに想いを伝える亮平に、戸惑いながら朝子も惹かれていく。しかし、朝子には亮平に告げられない秘密があった。亮平は、２年前に朝子が大阪に住んでいた時、運命的な恋に落ちた恋人・鳥居麦に顔がそっくりだったのだ――。</p>
                    </section>
                    <section class="section_story--content">
                        <h3 class="section_story--content--title">５年後。</h3>
                        <p>亮平と朝子は共に暮らし、亮平の会社の同僚・串橋や、朝子とルームシェアをしていたマヤと時々食事を４人で摂るなど、平穏だけど満たされた日々を過ごしていた。ある日、亮平と朝子は出掛けた先で大阪時代の朝子の友人・春代と出会う。７年ぶりの再会。２年前に別れも告げずに麦の行方が分からなくなって以来、大阪で親しかった春代も、麦の遠縁だった岡崎とも疎遠になっていた。その麦が、現在はモデルとなって注目されていることを朝子は知る。亮平との穏やかな生活を過ごしていた朝子に、麦の行方を知ることは小さなショックを与えた。</p>
                    </section>
                    <div class="section_story--content">
                        <p>一緒にいるといつも不安で、でも好きにならずにいられなかった麦との時間。
                            <br>ささやかだけれど、いつも温かく包み、安心を与えてくれる亮平との時間。
                            <br>朝子の中で気持ちの整理はついていたはずだった……。</p>
                    </div>
                </article>

                <span class="cat_image"><img src="/netemosametemo/static/img/cat_img.png" alt="Cat"></span>
            </section>
        </div>

        <picture class="section_story--image">
            <source srcset="static/img/story_sub_img.jpg"
                media="(min-width: 640px)">
            <img src="/netemosametemo/static/img/story_sub_img_small.jpg">
        </picture>
    </div>
</template>

<script>
export default {
    name: 'story',
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Story.vue